module.exports = __webpack_public_path__ + "static/media/partitions_gwp_60y_n.a5f5c1f5.csv";